import intersection from 'lodash/intersection'
import isEmpty from 'lodash/isEmpty'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import ListCloseIcon from '@pc/components/Works/Panel/shared/List/ListCloseIcon'
import ListItem from '@pc/components/Works/Panel/shared/List/ListItem'
import ListItemDescription from '@pc/components/Works/Panel/shared/List/ListItemDescription'
import ListItemName from '@pc/components/Works/Panel/shared/List/ListItemName'
import ListItemParagraph from '@pc/components/Works/Panel/shared/List/ListItemParagraph'
import ListOpenIcon from '@pc/components/Works/Panel/shared/List/ListOpenIcon'
import type { BigCategory, SmallCategory } from '@pc/components/Works/Panel/types'
import OccupationCheckboxes from './OccupationCheckBoxes'
import type { MouseEvent } from 'react'

interface PropsType {
  selectedJobIds: string[]
  changeJobIds: (arg: string[]) => void
  bigCategory: BigCategory
  smallCategories: SmallCategory[]
}

const OccupationListItem = styled(ListItem)`
  cursor: pointer;
`

const OccupationListItemParagraph = styled(ListItemParagraph)`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;

  svg {
    position: absolute;
    right: 15px;
  }
`

const OccupationListItemName = styled(ListItemName)`
  font-weight: bold;
  min-width: 250px;
`

const OccupationListDescription = styled(ListItemDescription)`
  margin-right: 30px;
`

const BigOccupationItem = (props: PropsType) => {
  const { bigCategory, smallCategories, selectedJobIds, changeJobIds } = props
  const [childrenIsOpen, setChildrenIsOpen] = useState(false)

  const toggleChildren = (e: MouseEvent) => {
    e.preventDefault()
    setChildrenIsOpen(!childrenIsOpen)
  }

  const joinSmallCategorieNames = smallCategories.map((smallCategory) => smallCategory.attributes.name).join('、')

  useEffect(() => {
    const isSelectedBeforehand = !isEmpty(
      intersection(
        smallCategories.map((smallCategory) => smallCategory.attributes.id.toString()),
        selectedJobIds
      )
    )
    if (isSelectedBeforehand) {
      setChildrenIsOpen(true)
    }
  }, [smallCategories, selectedJobIds])

  return (
    <OccupationListItem>
      <OccupationListItemParagraph onClick={toggleChildren}>
        <OccupationListItemName>{bigCategory.attributes.name}</OccupationListItemName>
        <OccupationListDescription>{joinSmallCategorieNames}</OccupationListDescription>
        {childrenIsOpen ? <ListCloseIcon /> : <ListOpenIcon />}
      </OccupationListItemParagraph>
      {childrenIsOpen ? (
        <OccupationCheckboxes
          bigCategory={bigCategory}
          smallCategories={smallCategories}
          selectedJobIds={selectedJobIds}
          changeJobIds={changeJobIds}
        />
      ) : null}
    </OccupationListItem>
  )
}

export default BigOccupationItem
